import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Sidebar from "./Sidebar";

export default function ProtectedShell() {
  const { user, loading, logout } = useAuth();
  const location = useLocation();

  // Session callback should be handled before this renders, but if not...
  if (location.hash?.includes("session_id=")) {
    return null;
  }

  if (loading) {
    return (
      <div className="loading-page">
        <div className="spinner"/>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Pending users see access request screen
  if (user.role === "pending") {
    return (
      <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'var(--bg)',padding:24}}>
        <div style={{maxWidth:480,textAlign:'center'}} data-testid="pending-access-screen">
          <div style={{width:72,height:72,borderRadius:'50%',background:'linear-gradient(135deg, #ECEAE4, #D9D2C3)',display:'grid',placeItems:'center',margin:'0 auto 20px',fontSize:28,fontFamily:'var(--serif)',color:'var(--text-1)'}}>
            {(user.name || '?')[0].toUpperCase()}
          </div>
          <h2 style={{fontFamily:'var(--serif)',fontSize:24,fontWeight:400,margin:'0 0 8px'}}>Access Pending</h2>
          <p style={{color:'var(--text-2)',fontSize:14,lineHeight:1.6,margin:'0 0 20px'}}>
            Hello <strong>{user.name}</strong>, your account (<span style={{fontFamily:'var(--mono)',fontSize:12}}>{user.email}</span>) has been registered but is awaiting admin approval.
          </p>
          <div style={{background:'var(--surface)',border:'1px solid var(--line)',borderRadius:8,padding:16,marginBottom:20,textAlign:'left',fontSize:13,color:'var(--text-2)',lineHeight:1.7}}>
            <div style={{fontWeight:600,color:'var(--text-1)',marginBottom:6}}>What happens next?</div>
            <ul style={{margin:0,paddingLeft:18}}>
              <li>The system administrator has been notified of your request</li>
              <li>Once approved, you'll be able to access FIMS on your next sign-in</li>
              <li>For urgent access, contact the admin directly</li>
            </ul>
          </div>
          <div style={{fontSize:12,color:'var(--text-3)',marginBottom:16}}>
            Admin contact: <strong>kovid.verma@ssmch.in</strong>
          </div>
          <button onClick={logout} style={{padding:'8px 20px',fontSize:13,border:'1px solid var(--border)',borderRadius:6,background:'transparent',cursor:'pointer',color:'var(--text-2)'}} data-testid="pending-signout">
            Sign out
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="app">
      <Sidebar/>
      <main className="main">
        <Outlet/>
      </main>
    </div>
  );
}
